import axios from '@/utils/request'
var Qs = require('qs')

export default {


	// 2021-05-19
	findBySaleSettlementId(saleSettlementId) {
		return axios.get('/sale-settlement-items/find-by-sale-settlement-id/' + saleSettlementId)
	},
	// 2021-05-19
	exportExcelBySaleSettlementId(saleSettlementId) {
		return axios.put('/sale-settlement-items/export-excel-by-sale-settlement-id/' + saleSettlementId);
	},

}